export const policyCategories = [
  { path: "/admin/policy-configuration", title: "General Cover" },
  { path: "", title: "Savings Policy" },
  { path: "", title: "Credit Life" },
];

export const policyAttachmentCategories = [
  { path: "/admin/policy-application", title: "General Cover" },
  { path: "/admin/savings-policy/application", title: "Savings Policy" },
  { path: "", title: "Credit Life" },
];
